function initTabs(group) {
  const isMobile = () => window.innerWidth < 768;

  const links = group.querySelectorAll(".tab-menu-link");
  const contents = group.querySelectorAll(".tab-content");

  if (links.length === 0 || contents.length === 0) return;

  function closeAll() {
    links.forEach(link => {
      link.classList.remove("active");
      link.setAttribute("aria-expanded", "false");
    });

    contents.forEach(content => {
      content.classList.remove("active");
      content.setAttribute("hidden", "");
    });
  }

  function activateTab(link) {
    if (isMobile()) {
      const tabItem = link.closest(".tab-item");
      const content = tabItem?.querySelector(".tab-content");

      const isOpen = link.classList.contains("active");
      closeAll();

      if (!isOpen && content) {
        link.classList.add("active");
        link.setAttribute("aria-expanded", "true");

        content.classList.add("active");
        content.removeAttribute("hidden");

        const yOffset = -64;
        const y = link.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    } else {
      const targetId = link.dataset.target;
      const content = group.querySelector(`#${targetId}`);
      if (!content) return;

      closeAll();

      link.classList.add("active");
      content.classList.add("active");
      link.setAttribute("aria-expanded", "true");
      content.removeAttribute("hidden");
    }
  }

  links.forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      activateTab(this);
    });

    link.setAttribute("aria-expanded", "false");
  });

  contents.forEach(content => {
    content.setAttribute("hidden", "");
  });

  const anyActive = [...links].some(link => link.classList.contains("active"));
  if (!anyActive && links.length > 0) {
    activateTab(links[0]);
  }
}

document.querySelectorAll(".tab-group").forEach(group => initTabs(group));
